export const getProductPackageTypesSuccess = (productPackageTypes) => {
    return {
        type: "GET_PRODUCT_PACKAGE_TYPES_SUCCESS",
        payload: productPackageTypes
    }
};
